import get from 'lodash/get';

// Constants
import { PUBLIC_URL } from '../constants/app'


export function getCustomers(payment) {
  let
    invoices = get(payment, 'invoices'),
    customers = null;

  function getName(obj) {
    let name = get(obj, 'customer.name');
    let legal_name = get(obj, 'customer.legal_name');
    let tax_profile = get(obj, 'customer.tax_profile');

    if (!name) name = legal_name;
    if (!name) name = tax_profile;

    return name;

  } // Get name

  if (Array.isArray(invoices)) {

    if (invoices.length === 0) customers = `No disponible`
    else if (invoices.length === 1) customers = getName(invoices[0]);
    else if (invoices.length > 1) customers = getName(invoices[0]);
    //else if (invoices.length > 1) customers = `${getName(invoices[0])} (${invoices.length} facturas)`;

  } // END if

  return customers ? customers : `No disponible`;

} // END getCustomers

export function getIdentifier(payment) {
  let
    invoices = get(payment, 'invoices'),
    customers = null;

  function getContractIdentifier(obj) {
    let identifier = get(obj, 'contract.identifier');

    if (!identifier) identifier = 'No disponible';

    return identifier;

  } // END - getContractIdentifier

  if (Array.isArray(invoices)) {

    if (invoices.length === 0) customers = `No disponible`
    else if (invoices.length === 1) customers = getContractIdentifier(invoices[0]);
    else if (invoices.length > 1) customers = getContractIdentifier(invoices[0]);

  } // END if

  return customers ? customers : `No disponible`;

} // END getIdentifier

/**
 * getPolicyNumber - Return the policy number
 * @param {object} payment data of payment
 */
export function getPolicyNumber(payment) {
  let invoices = get(payment, 'invoices');
  let customers = null;

  function getContractPolicyNumber(obj) {
    let identifier = get(obj, 'contract.identifier');
    let newIdentifier;
    let patter = 'product_id'
    let policyNumber;
    /**
     * returnPolicyNumber - Return policy number
     * @param {string} id identifier
     * @param {string} product product_id
     */
    function returnPolicyNumber(id, product) {
      newIdentifier = id.replace(product, patter);
      policyNumber = newIdentifier.split(patter);
      return policyNumber[1];
    }

    if (identifier){
      if (identifier.includes('211')) {
        return returnPolicyNumber(identifier, '211'); // Auto
      } else if (identifier.includes('420')) {
        return returnPolicyNumber(identifier, '420'); // Hogar
      } else if (identifier.includes('430')) {
        return returnPolicyNumber(identifier, '430'); // Empresa
      } else if (identifier.includes('501')) {
        return returnPolicyNumber(identifier, '501'); // Responsabilidad Civil
      } else if (identifier.includes('606')) {
        return returnPolicyNumber(identifier, '606'); // Gastos Medicos
      } else if (identifier.includes('901')) {
        return returnPolicyNumber(identifier, '901'); // Vida Individual
      } else {
        return 'No disponible';
      }
    } else {
      return 'No disponible';
    }
  } // END - getContractPolicyNumber

  if (Array.isArray(invoices)) {

    if (invoices.length === 0) customers = `No disponible`
    else if (invoices.length === 1) customers = getContractPolicyNumber(invoices[0]);
    else if (invoices.length > 1) customers = getContractPolicyNumber(invoices[0]);

  } // END if

  return customers ? customers : `No disponible`;

} // END getPolicyNumber

export function getCurrentEnv(){
  // [H-025] Ambiente obtenido de variable de entorno — evita exponer URLs
  // de ambientes internos (dev.app.porcobrar.com, stage.app.porcobrar.com) en el bundle.
  return process.env.REACT_APP_ENV || false;

} // END getCurrentEnv



export function isPublicRoute(){
  const publicRoutes = [`/portal/`, '/checkout/', '/cobranza/'];
  let retVal = publicRoutes.some(value => window.location.href.indexOf(`${PUBLIC_URL}${value}`) !== -1);
  return retVal;

} // END isPublicRoute

export function pricingRoute(pathname = '') {
  if(pathname.includes('app')) return 'app';
  if(pathname.includes('pricing')) return 'pricing';

} // END pricingRoute


// WEBPACK FOOTER //
// ./src/libs/helpers.js